module.exports = __webpack_public_path__ + "img/founders_07.6817364f.jpg";